
<div class="editor" [ngStyle]="{ 'width': width ? width : '' }">

  <div *ngIf="label" [ngStyle]="{ 'width': label_width ?? '' }">
    <label>{{label}} : </label>
  </div>

  <select type="text" [(ngModel)]="value" [disabled]="_disabled" style="width:120px;">
    <option *ngFor="let month of months" [value]="month.id">{{ month.name }}</option>
  </select>

</div>
